export default function getToolTipTextForTableProperty(formattedPropertyName, dashboardLabels) {
  if (dashboardLabels) {
    const foundLabel = dashboardLabels.find((label) => `${label.header}`.trim() === `${formattedPropertyName}`.trim());
    if (foundLabel) {
      return foundLabel.tooltip;
    }
  }
  return formattedPropertyName;
}
